import React from "react";
import ARROW_DOWN from "../../assets/images/arrow-down.png";
import { useAppSelector } from "../../app/hooks";
import { formatIndianNumber } from "../../_helpers/formatUtils";

interface FlightRPriceProps {
  sortedPriceList: any;
  // flightSearchDetails: any;
  openFlightRate: boolean;
  routeIndex: number;
  setOpenFlightRate: (openFlightRate: boolean) => void;
  priceDetails: any;
  handleRadioButtonChange: (id: string) => void;
  prefix: string;
}

const FlightRPrice = ({
  sortedPriceList,
  // flightSearchDetails,
  openFlightRate,
  priceDetails,
  routeIndex,
  handleRadioButtonChange,
  setOpenFlightRate,
  prefix,
}: FlightRPriceProps) => {
  const flightSearchDetails = useAppSelector(
    (state) => state.home.flightSearchDetails
  );

  const { ADULT, CHILD, INFANT } = flightSearchDetails;
  return (
    <div className="route-price-col">
      {sortedPriceList?.map((fare: any, index: number) => {
        let totalAdultPrice = 0;
        let totalChildPrice = 0;
        let totalInfantPrice = 0;

        fare.FareDetails.forEach((fare: any) => {
          // const totalAmount = fare.Total_Amount || 0;
          const totalAmount =
            (fare.Total_Amount || 0) - (fare.Service_Fee_Amount || 0);

          switch (fare.PAX_Type) {
            case 0:
              totalAdultPrice += totalAmount * ADULT || 0;
              break;
            case 1:
              totalChildPrice += totalAmount * CHILD || 0;
              break;
            case 2:
              totalInfantPrice += totalAmount * INFANT || 0;
              break;
            default:
              break;
          }
        });

        const totalPrice = totalAdultPrice + totalChildPrice + totalInfantPrice;

        const RefundableType = fare?.Refundable;

        /* CHNAGE IN RADIO BUTTON */
        return (
          <div
            className={`route-price ${
              index > 2 && !openFlightRate ? "d-none" : ""
            }`}
            key={`${prefix}-${routeIndex}-${index}`}
          >
            <input
              type="radio"
              value={priceDetails}
              checked={priceDetails?.Fare_Id === fare.Fare_Id}
              name={`${prefix}_radio_${routeIndex}`}
              id={`${prefix}_radio_${routeIndex}`}
              onChange={() => handleRadioButtonChange(fare?.Fare_Id)}
            />
            <label htmlFor={`${prefix}_radio_${routeIndex}`}></label>₹{" "}
            {formatIndianNumber(totalPrice)}
            <a href="">
              {/* <span>{tp?.fareIdentifier}</span>{" "} */}
              {fare?.FareDetails[0]?.FareClasses[0]?.Class_Desc}
              {/* {fare?.FareDetails[0]?.FareClasses.map(
                (fClass: any, index: number) =>
                  getNewCabinClassnameFromCode(fClass?.Class_Code)
                    ? fClass?.Class_Code
                    : // +
                      //   getNewCabinClassnameFromCode(fClass?.Class_Code) +
                      //   `${
                      //     index + 1 < fare?.FareDetails[0]?.FareClasses?.length
                      //       ? ", "
                      //       : ""
                      //   }`
                      ""
              )} */}
              {fare?.Food_onboard === "F" ? ", Free Meal" : ""}
              {RefundableType
                ? (fare?.Food_onboard === "F" ? ", " : ", ") + "Refundable"
                : ""}
            </a>
          </div>
        );
      })}
      {sortedPriceList?.length > 3 && (
        <div className="expand-toggle">
          <a
            className={`${openFlightRate ? "up-arrow" : "down-arrow"} `}
            onClick={() => {
              setOpenFlightRate(!openFlightRate);
            }}
          >
            <img src={ARROW_DOWN} alt="" />
          </a>
        </div>
      )}
    </div>
  );
};

export default FlightRPrice;
